import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { AcepDossier } from 'app/shared/models/acep/acep-dossier.model';
import { HttpHeadersUtil } from 'app/shared/utils/http-headers.util';
import { endpoints } from 'environments/endpoints';
import { RenovationProjectAssignmentDto } from 'app/shared/models/renovation-projects/dtos/renovation-project-assignment.dto';

@Injectable({
  providedIn: 'root'
})
export class AcepDossierService {
  private baseRoute = environment.GATEWAY_API + endpoints.dossiers.baseRoute;
  private subRoutes = endpoints.dossiers.subRoutes;

  constructor(private _httpClient: HttpClient) {}

  getCurrentDossiers(): Observable<AcepDossier[]> {
    return this._httpClient.get<Array<Partial<AcepDossier> & { guidId?: string; GuidId?: string }>>(
      `${this.baseRoute}${this.subRoutes.getAll}`,
      HttpHeadersUtil.prepareDefaultHeaders()
    ).pipe(map(data => (data ?? []).map(item => new AcepDossier(item))));
  }

  getDossier(id: string): Observable<AcepDossier> {
    return this._httpClient.get<Partial<AcepDossier> & { guidId?: string; GuidId?: string }>(
      `${this.baseRoute}${this.subRoutes.getDossier}${id}`,
      HttpHeadersUtil.prepareDefaultHeaders()
    ).pipe(map(data => new AcepDossier(data)));
  }

  assignment(dto: RenovationProjectAssignmentDto): Observable<{ success: boolean }> {
    const url = `${this.baseRoute}${this.subRoutes.assignment}`;
    return this._httpClient.post<{ success: boolean }>(
      url,
      dto,
      HttpHeadersUtil.prepareDefaultHeaders()
    );
  }

  getDataChanges(id: number, typeDossier: string): Observable<string> {
    return this._httpClient.get<string>(
      `${this.baseRoute}${this.subRoutes.getDataChanges + id + '/' + typeDossier}`,
      HttpHeadersUtil.prepareDefaultHeaders()
    );
  }  

  getExportExcelUrl(): string {
    return `${this.baseRoute}${this.subRoutes.exportExcel}`;
  }
}
